import { createHoverDrawPictogram } from './hover-draw-pictogram';

const PATHS = [
  // Title bar dots
  'M29,3.5C29,3.776,28.776,4,28.5,4S28,3.776,28,3.5S28.224,3,28.5,3S29,3.224,29,3.5z M26.5,3C26.224,3,26,3.224,26,3.5S26.224,4,26.5,4S27,3.776,27,3.5S26.776,3,26.5,3z M24.5,3C24.224,3,24,3.224,24,3.5S24.224,4,24.5,4S25,3.776,25,3.5S24.776,3,24.5,3z',
  // Window frame
  'M31,30.36H1c-0.199,0-0.36-0.161-0.36-0.36V2c0-0.199,0.161-0.36,0.36-0.36h30c0.199,0,0.36,0.161,0.36,0.36v28C31.36,30.199,31.199,30.36,31,30.36z M1.36,29.64h29.28V5.36H1.36V29.64z M1.36,4.64h29.28V2.36H1.36V4.64z',
  // Code slash
  'M13.5,24.142l-0.662-0.283l6-14l0.662,0.283L13.5,24.142z',
  // Right bracket
  'M21.424,21.255l-0.51-0.51L24.66,17l-3.746-3.746l0.51-0.509l4,4c0.141,0.141,0.141,0.369,0,0.509L21.424,21.255z',
  // Left bracket
  'M10.915,21.255l-4-4c-0.141-0.141-0.141-0.369,0-0.509l4-4l0.509,0.509L7.678,17l3.745,3.745L10.915,21.255z',
];

export const CodeSyntaxPictogram = createHoverDrawPictogram('CodeSyntaxPictogram', PATHS);
